// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-area[data-v-fdd1ea2a] {\n  max-height: 400px;\n  max-width: 1600px;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
